import { render, staticRenderFns } from "./NormalSearchNav520.vue?vue&type=template&id=50aa7f2d&scoped=true&"
import script from "./NormalSearchNav520.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav520.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50aa7f2d",
  null
  
)

export default component.exports